import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  ButtonV2Size,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';
import { MenuItem } from './MenuItem';

export const ENCODINGS = {
  utf_8: 'utf-8',
  shift_jis: 'shift_jis',
} as const;

export type ImportExportHistoryEncoding =
  (typeof ENCODINGS)[keyof typeof ENCODINGS];

export type Props = {
  isDisabled?: boolean;
  onExport: (encoding: ImportExportHistoryEncoding) => void;
  size?: ButtonV2Size;
};

export const ExportButton: FC<Props> = memo(
  ({ isDisabled, onExport, size = 'sm' }) => {
    const { t } = useTranslation();

    return (
      <ActionMenu
        buttonProps={useMemo(
          () => ({
            name: t('export_csv.button_label'),
            children: t('export_csv.button_label'),
            isDisabled: isDisabled,
            color: 'primary',
            rightIcon: <IconTrailing height={0} width={0} />,
            size: size,
          }),
          [isDisabled, t, size]
        )}
        type='button'
        disabled={isDisabled}
        items={useMemo(
          () => [
            {
              key: 'UTF8',
              label: (
                <MenuItem
                  label={t('export_csv.options.utf_8')}
                  tooltip={t('export_csv.options.utf_8.tooltip')}
                />
              ),
              onClick: () => {
                onExport(ENCODINGS.utf_8);
              },
            },
            {
              key: 'shiftJis',
              label: (
                <MenuItem
                  label={t('export_csv.options.shift_jis')}
                  tooltip={t('export_csv.options.shift_jis.tooltip')}
                />
              ),
              onClick: () => {
                onExport(ENCODINGS.shift_jis);
              },
            },
          ],
          [onExport, t]
        )}
      />
    );
  }
);

ExportButton.displayName = 'ExportButton';
